'use strict';

angular.module('buyers')
.directive('onScroll', function() {
    return {
        restrict : "A",
        link : function($scope, $el, $attr) {
            var raw = $el[0];
            
            $el.bind('scroll', function() {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                    $scope.$apply($attr.onScroll);
                }
            });
        }
    };
});
